import { createFileRoute } from '@tanstack/react-router';

import { createTestEmployeeScreen, loadDataprevEmployeeMessages, loadDataprevEmployeeScreens, testToolSearch } from '@/modules/dataprev-employee/route';
import { lazyScreen } from '@/shared/screen';

// Criar CPF para Teste no caminho do legado (`router.tsx:1317-1327`), só com ENABLE_DATAPREV_TEST === 1
// (a guarda da casca lê `access.flag` do manifesto). Arquivo leve (JS inicial).
export const Route = createFileRoute('/_app/ccb/criar-cpf-teste/')({
  validateSearch: testToolSearch,
  staticData: { screen: createTestEmployeeScreen },
  loader: () => loadDataprevEmployeeMessages(),
  component: lazyScreen(loadDataprevEmployeeScreens, 'CreateTestEmployeeRouteScreen'),
});
